import { jdiColorFetch } from '../colorFetchV2';
import { FooterMenuRequest, FetchResponse, SubmieEmailRequest } from './footer.interface';

/**
 * 获取Footer菜单
 * @param requestData
 * @returns
 */
export const fetchQuestionList = async (requestData: FooterMenuRequest): Promise<FetchResponse> => {
  const res = await jdiColorFetch(`user_help_getQuestionList`, {
    method: 'post',
    bodyQuery: requestData,
  });
  return res;
};

/**
 * 订阅邮箱提交
 * @param requestData
 * @returns
 */
export const fetchSubmitEmail = async (requestData: SubmieEmailRequest): Promise<FetchResponse> => {
  const res = await jdiColorFetch(`user_account_subscribe`, {
    method: 'post',
    bodyQuery: requestData,
  });
  return res;
};
